import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';

type InfoTipProps = {
  title: string;
  /** Accessible label */
  label?: string;
};

/** Compact ⓘ control for column/header explanations. */
const InfoTip: React.FC<InfoTipProps> = ({ title, label = 'More info' }) => (
  <Tooltip title={title} arrow placement="top" enterTouchDelay={0}>
    <IconButton
      size="small"
      aria-label={label}
      onClick={(e) => e.stopPropagation()}
      sx={{ p: 0.25, ml: 0.25, verticalAlign: 'middle' }}
    >
      <InfoOutlined sx={{ fontSize: 16, color: 'action.active' }} />
    </IconButton>
  </Tooltip>
);

export default InfoTip;
